import { BaseModel } from 'ag-common-lib/lib/models/base.model';
import { LookupBase } from 'ag-common-lib/lib/models/utils/lookup-base.model';
import { LookupKeys } from 'ag-common-lib/lib/models/crm/lookup.model';
import { PolicyTypes } from 'ag-common-lib/lib/models/utils/policy.model';

export enum PolicySignersKeys {
  agentDbId = 'agentDbId',
  agentId = 'agentId',
  agentEmail = 'agentEmail',
  agentFirstName = 'agentFirstName',
  agentLastName = 'agentLastName',
  agentMgaId = 'agentMgaId',
  policyDbId = 'policyDbId',
  policyType = 'policyType',
  policyVersion = 'policyVersion',
  lastSignedVersion = 'lastSignedVersion',
}

export class PolicySigners extends BaseModel {
  [PolicySignersKeys.agentDbId]: string;
  [PolicySignersKeys.agentId]: string;
  [PolicySignersKeys.agentEmail]: string;
  [PolicySignersKeys.agentFirstName]: string;
  [PolicySignersKeys.agentLastName]: string;
  [PolicySignersKeys.agentMgaId]: string = '';
  [PolicySignersKeys.policyDbId]: string;
  [PolicySignersKeys.policyVersion]: string;
  [PolicySignersKeys.policyType]: PolicyTypes;
  [PolicySignersKeys.lastSignedVersion]?: string;
}

export const POLICY_SIGNERS_LOOKUP: LookupBase[] = [
  {
    [LookupKeys.value]: PolicySignersKeys.agentId,
    [LookupKeys.description]: 'Agent ID',
  },
  {
    [LookupKeys.value]: PolicySignersKeys.agentEmail,
    [LookupKeys.description]: 'Agent Email',
  },
  {
    [LookupKeys.value]: PolicySignersKeys.agentFirstName,
    [LookupKeys.description]: 'Agent First Name',
  },
  {
    [LookupKeys.value]: PolicySignersKeys.agentLastName,
    [LookupKeys.description]: 'Agent Last Name',
  },
  {
    [LookupKeys.value]: PolicySignersKeys.policyType,
    [LookupKeys.description]: 'Type',
  },
  {
    [LookupKeys.value]: PolicySignersKeys.policyVersion,
    [LookupKeys.description]: 'Version',
  },
];
